export default [
  {
    key: 'employeeId',
    label: 'breadcrumb.employee',
    type: 'async-single-selection',
    repository: 'allOperator',
    mustExcludedIds: [],
    alwaysFresh: true,
    isCustomParams: true,
    clearable: true,
    selectionKey: 'id',
    selectionLabel: 'name',
    placeholder: 'placeholder.selectEmployee',
  },
  {
    key: 'date',
    label: 'field.startDate',
    type: 'date',
    md: 4,
    lg: 4,
  },
  {
    key: 'endDate',
    label: 'field.endDate',
    type: 'date',
    md: 4,
    lg: 4,
  },
]
